const Footer = () => {
  return (
    <footer className="bg-[#0f0f1a] border-t border-white/10 mt-auto" data-testid="app-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
          {/* About Section - Right side in RTL */}
          <div>
            <h3 className="text-xl font-bold text-white mb-3">
              RasheedGPT
            </h3>
            <p className="text-white/60 text-sm leading-relaxed">
              منصة تعليمية ذكية صُممت لمساعدة أولياء الأمور في تعليم أبنائهم خلال التحول للتعلم عن بُعد وفي الظروف الصعبة. نؤمن بأن التعليم حق لكل طفل، ونسعى لتسهيل رحلة التعلم المنزلي بأدوات ذكية ومحتوى تفاعلي.
            </p>
          </div>

          {/* Contact Section - Left side in RTL */}
          <div className="md:text-left">
            <h3 className="text-lg font-bold text-white mb-3">
              تواصل معنا
            </h3>
            <div className="space-y-3">
              <a 
                href="mailto:support@rasheedgpt.com" 
                className="text-white/60 hover:text-[#4da6ff] transition-colors flex items-center md:justify-end gap-3 text-sm"
                data-testid="footer-email-link"
              >
                <span dir="ltr">support@rasheedgpt.com</span>
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </a>
              <a 
                href="tel:+970599292050" 
                className="text-white/60 hover:text-[#4da6ff] transition-colors flex items-center md:justify-end gap-3 text-sm"
                data-testid="footer-phone-link"
              >
                <span dir="ltr">+970 599 292 050</span>
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="border-t border-white/10 mt-8 pt-6 text-center">
          <p className="text-white/40 text-sm">
            جميع الحقوق محفوظة © 2024 RasheedGPT
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
